$(document).ready(function () {
    $(".js-tab-item").not(":first").hide();

    $(".js-tabs-container .js-tab").click(function (event) {
        event.preventDefault();

        $(".js-tabs-container .js-tab").removeClass("active").eq($(this).index()).addClass("active");
        $(".js-tab-item").hide().eq($(this).index()).trigger('tab.opened').fadeIn()
    }).eq(0).addClass("active");
});
